<template>
<div id="page-carga_adjuntos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Cargar Referencia Pedimento" class="elevation-1 px-5 py-3" >
                        <v-card-actions>
                       
                            <v-spacer></v-spacer>

                                     <exportar-excel :data="vacio" :exportFields="headings" name="LayoutOrdenesAbiertas.xlsx" >
                                                <v-btn fab x-small  dark color="purple darken-2" title="Descargar Layout" v-tippy>
                                                    <v-icon dark>receipt</v-icon>
                                                </v-btn>
                                            </exportar-excel>
                               
                          
                        </v-card-actions>
                    <v-card-text>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <p class="text-justify" >
                                            <v-icon color="indigo" >info</v-icon>
                                            <strong> La información se sustituira cada vez que se cargue un nuevo archivo.</strong>
                                              
                                        </p>

                                        <v-flex xs12>
                                          <file-pond allowPaste=false name="certificado" ref="pond" requiered class-name="my-pond" labelIdle="<span class='filepond--label-action'> Arrastre o seleccione su archivo .XLSX   Aqui </span>" labelInvalidField="Archivo no valido" labelFileWaitingForSize="Calculando el tamaño" labelFileSizeNotAvailable="Tamaño no valido" labelFileLoading="Cargando.." labelFileLoadError="Error al cargar" labelFileProcessing="Subiendo" labelFileProcessingComplete="Carga completa" labelFileProcessingAborted="Carga cancelada" labelFileProcessingError="Error durante la carga" labelFileProcessingRevertError="Error" labelFileRemoveError="Error al eliminar" labelTapToCancel="Cancelar" labelTapToRetry="Reintentar" labelTapToUndo="Deshacer" labelButtonRemoveItem="Eliminar" labelButtonAbortItemLoad="Abortar" labelButtonRetryItemLoad="Reintentar" labelButtonAbortItemProcessing="Cancelar" labelButtonUndoItemProcessing="Deshacer" labelButtonRetryItemProcessing="Reintentar" labelButtonProcessItem="Subir" accepted-file-types=".xlsx" v-bind:files="file_xlsx" v-bind:server="myServer" allowFileTypeValidation />
                                           
                                        </v-flex>

                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="success" :loading="loading" @click.native="send()" >
                                        <v-icon>done</v-icon>Enviar
                                    </v-btn>
                        </v-card-actions>
                  


                    </v-card-text>
                </base-material-card>

             
      <!--     <v-card-actions>
            <v-btn
              color="success"
              min-width="100"
              class="pl-0"
            >
              Sign In
            </v-btn>
          </v-card-actions> -->
            </v-flex>
        </v-layout>

    </v-container>
</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'
// Import FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";

// Import styles
import "filepond/dist/filepond.min.css";
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
    created: function () {
        this.URL = this.$hostname;
        this.cliente = this.$local_storage.get("id_cliente");

    },


      data() {
        return {
            fab: false,
            URL: "",
            file: null,
            model_filters: '',
            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "E-Drive",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Cargar Referencia Pedimento",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            file_xlsx: [],    
            update: false,
            loading: false,
            myServer: {
            process: (fieldName, file, metadata, load) => {
                //this.file_c = file;
                const fr = new FileReader();
                fr.readAsDataURL(file);
                fr.addEventListener('load', () => {
                    this.file = fr.result; // archivo en base64
                });

                // simulates uploading a file
                setTimeout(() => {
                    load(Date.now());
                }, 5);
            },
            load: (source, load) => {
                // simulates loading a file from the server
                fetch(source)
                    .then(res => res.blob())
                    .then(load);
            }
        },
            headings: {
                    "id":"id",
                    "reg_control": "reg_control", 
                    "planta": "planta", 
                    "destination": "destination", 
                    "pu_num": "pu_num",
                    "po_line_num": "po_line_num", 
                    "vendor": "vendor",
                    "no_parte": "no_parte",
                    "item_desc": "item_desc",
                    "qty": "qty", 
                    "uom": "uom", 
                    "unit_price":  "unit_price", 
                    "currency": "currency", 
                    "ext_cur": "ext_cur", 
                    "ext_dol": "ext_dol"
                },
                 vacio: [{
                    "id":"",
                    "reg_control": "", 
                    "planta": "", 
                    "destination": "", 
                    "pu_num": "",
                    "po_line_num": "", 
                    "vendor": "",
                    "no_parte": "",
                    "item_desc": "",
                    "qty": "", 
                    "uom": "", 
                    "unit_price":  "", 
                    "currency": "", 
                    "ext_cur": "", 
                    "ext_dol": ""
                   } ],
            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'xlsx',

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {
        
      
        send: function () {
             
            var thisObj = this;
            var datos = {
                "cliente":parseInt(this.$local_storage.get("id_cliente")),
                "usuario": parseInt(this.$local_storage.get("id_usuario")),
                "file": thisObj.file

            }
            axios.post(this.$hostname + 'catalogos/ordenes/', datos);
                this.$swal({
                            type: "success",
                            title: "¡Operación no Exitosa!",
                            text: "El archivo se envió correctamente, el proceso de carga comenzara internamente, Recibira una notificación con el resultado.",
                            footer: '',
                        });

                     this.$swal({
         type: "success",
         title: "¡Operación no Exitosa!",
         text: "El archivo se envió correctamente, el proceso de carga comenzara internamente, Recibira una notificación con el resultado.",
         footer: '',
        showCancelButton: false,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
            
        }});
        },

        
    }
};
</script>
